import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, ListGroup, ListGroupItem } from "reactstrap";
import DatePicker from "react-date-picker";
import moment from "moment";

import Table from "./components/Table";
import PageHead from "../../component/pageHead/PageHead";
import CustomLoader from "../../component/CustomLoader/CustomLoader";
import editIcon from "../../assets/icons/edit.png";
// import api from "../../config/api";
import historyAction from "../../redux/history/action";
import authAction from "../../redux/auth/action";
import fundPricesAction from "../../redux/fundPrices/action";
import scheduleSubmissionReportAction from "../../redux/scheduleSubmissionReport/action";
import api from "../../config/api";
import { isNetworkRequestFailedError } from "../../config/helpers";

class ScheduleSubmissionReport extends Component {
  state = {
    showCalender: true,
    data: null,
  };

  componentDidMount() {
    const { history, setHistory } = this.props;
    setHistory(history);
  }

  handlePickerChange = (key, value) => {
    let { setAlertMessage, to, changeScheduleSubmissionReport } = this.props;

    if (key === "from" && moment(to).isBefore(value)) {
      this.setState({ showCalender: false }, () => {
        // this.getPriceDateRange(null, value);
        this.setState({ showCalender: true });
        setAlertMessage({
          type: "error",
          message: "From date can not be higher than to",
        });
      });
      return;
    }

    const payload = {
      from: this.props.from,
      to: this.props.to,
    };

    payload[key] = value;

    changeScheduleSubmissionReport({ [key]: value });
    this.fetchData(payload);
  };

  changeDate = (type) => {
    let from, to;

    if (type === "this_year") {
      from = moment().startOf("year");
      to = moment();
    }

    if (type === "last_year") {
      from = moment().subtract(1, "year").startOf("year");
      to = moment().subtract(1, "year").endOf("year");
    }

    if (type === "quarter") {
      from = moment().subtract(1, "quarter").startOf("quarter");
      to = moment().subtract(1, "quarter").endOf("quarter");
    }

    const payload = {
      from: new Date(moment(from).valueOf()),
      to: new Date(moment(to).valueOf()),
    };

    this.props.changeScheduleSubmissionReport({
      from: new Date(from),
      to: new Date(to),
    });

    this.fetchData(payload);
  };

  fetchData = async (data) => {
    const { user } = this.props;

    try {
      this.setState({ isLoading: true });

      const payload = {
        employerCode: user.User.employerCode,
        startDate: moment(data.from).format("YYYY-MMMM-DD"),
        endDate: moment(data.to).format("YYYY-MMMM-DD"),
      };

      const response = await api.submittedScheduleReport(payload, user.token);

      this.setState({ data: response.data.result });
    } catch (e) {
      this.props.setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e)
          ? () => this.fetchData(data)
          : null,
      });
    }

    this.setState({ isLoading: false });
  };

  render() {
    const { from, to } = this.props;
    const { isLoading, data } = this.state;
    // if (from) {
    //   console.log("from =>", from)
    //   console.log("moment(from) =>", new Date(moment(from)))
    // }

    return (
      <Container className="mt-3">
        <div>
          <PageHead
            title="SCHEDULE SUBMISSION REPORT"
            containerStyles={{ width: "100%" }}
          />
          <ListGroup className="mt-2">
            <ListGroupItem className="transaction-details-picker-container">
              <p className="pr-1">Time Period</p>
              <div className="transaction-details-picker">
                {this.state.showCalender && (
                  <DatePicker
                    calendarIcon={<CalenderIcon />}
                    calendarClassName="transaction-details-calender-main-container"
                    className="transaction-details-calender-field mx-1"
                    value={from}
                    format="M/d/yyyy"
                    onChange={(value) => this.handlePickerChange("from", value)}
                  />
                )}
                {this.state.showCalender && (
                  <DatePicker
                    calendarIcon={<CalenderIcon />}
                    calendarClassName="transaction-details-calender-main-container"
                    className="transaction-details-calender-field mr-1"
                    value={to}
                    minDate={from && new Date(moment(from))}
                    format="M/d/yyyy"
                    onChange={(value) => this.handlePickerChange("to", value)}
                  />
                )}
              </div>
              <div className="transaction-details-calender-btns-container">
                <button
                  onClick={this.changeDate.bind(this, "this_year")}
                  className="transaction-details-calender-btn"
                >
                  This Year
                </button>
                <button
                  onClick={this.changeDate.bind(this, "last_year")}
                  className="transaction-details-calender-btn mx-1"
                >
                  Last Year
                </button>
                <button
                  onClick={this.changeDate.bind(this, "quarter")}
                  className="transaction-details-calender-btn"
                >
                  Last Quarter
                </button>
              </div>
            </ListGroupItem>
          </ListGroup>
          {data && <Table data={data} />}
        </div>
        {isLoading && <CustomLoader />}
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    allFunds: state.fundPrices.allFunds,
    ...state.scheduleSubmissionReport.input,
  };
};

const mapDispatchToProps = {
  setHistory: historyAction.setHistory,
  setAlertMessage: authAction.setAlertMessage,
  setAllFundsValues: fundPricesAction.setAllFundsValues,
  changeScheduleSubmissionReport:
    scheduleSubmissionReportAction.changeScheduleSubmissionReport,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScheduleSubmissionReport);

function CalenderIcon() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img alt="edit-icon" src={editIcon} width="20px" />
    </div>
  );
}
